<template>
  <div class="block_wrap">

    <div class="line">
      <div class="input_wrap main_name">
        <fg-input
            v-model="main_info.name"
            type="text"
            :label="translate('client.main_info.name')"
        />
      </div>

      <div class="filter checkbox">
        <div class="info">
          {{ active ? translate('client.active') : translate('client.inactive')}}
        </div>
        <label class="switch" @click.prevent="active = !active">
          <input type="checkbox" v-model="active">
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <div class="line">
      <div class="input_wrap">
        <fg-input
        v-model="main_info.city"
        type="text"
        :label="translate('client.main_info.city')"
        />
      </div>
      <div class="input_wrap">
        <fg-input
        v-model="main_info.inn"
        type="text"
        :label="translate('client.main_info.inn')"
        />
      </div>
    </div>

    <div class="line">
      <div class="text_wrap">
        <div class="form-group">
          <label>{{ translate('client.main_info.ur_name') }}</label>
          <textarea class="input_text" name="name" v-model="main_info.ur_name" />
        </div>
      </div>
    </div>

    <div class="line">
      <div class="text_wrap">
        <div class="form-group">
          <label>{{ translate('client.main_info.descr') }}</label>
          <textarea class="input_text" name="name" v-model="main_info.descr" />
        </div>
      </div>
    </div>

    <div class="line new_group" v-if="!this.main_info?.id">
      <div class="filter checkbox" @click.prevent="new_group = !new_group">
        <div class="info">
          {{ translate('client.new_group') }}
        </div>
        <label class="switch">
          <input type="checkbox" v-model="new_group">
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <div class="line" v-if="changes">
      <div class="button_wrap">
        <button
            class="btn btn-success btn-fill btn-wd"
            @click.prevent="edit_clients"
        >
          save
        </button>
      </div>
    </div>

  </div>
</template>
<script>

export default {
  name: 'MainInfo',
  props: ['client'],

  data () {
    return {
      main_info: {},
      active: true,
      new_group: true
    }
  },
  computed:{
    changes(){
      let main_info = Object.assign({}, this.main_info)
      let client_info = Object.assign({}, this.client)

      delete(client_info.ts_update)
      delete(main_info.ts_update)

      return JSON.stringify(main_info) !== JSON.stringify(client_info)
    }
  },
  created() {
    this.main_info = Object.assign({}, this.client)
    this.active = !Object.keys(this.main_info).length > 0 ? true : this.main_info.active === 1
  },
  watch:{
    client(){
      this.main_info = Object.assign({}, this.client)
      this.active = !Object.keys(this.main_info).length > 0 ? true : this.main_info.active === 1
    },
    active(){
      this.main_info.active  = this.active ? 1 : 0
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    edit_clients(){
      if (this.new_group && !this.main_info?.id) {
        this.main_info.create_group = 1
      }

      if (this.main_info?.id){
        this.$http.v1.editClientInfo(this.main_info.id, this.main_info, (response) => {
          this.$emit('update_client', response.data)
          this.global_notify('info', this.translate('client.saved_success'))
        })
      }else{
        this.$http.v1.saveClientInfo(this.main_info, (response) => {
          this.$emit('update_client', response.data)
          this.global_notify('info', this.translate('client.saved_success'))
          this.$emit('close')

          if (this.new_group) {
            this.$store.dispatch('deviceGroupUpdate')
          }
        })
      }
    }
  }
}

</script>

<style lang='scss' scoped>
  .block_wrap{
    text-align: left;
    .line{
      display: flex;
      justify-content: space-between;
      text-align: left;
      &.new_group{
        margin-bottom: 10px;
        .filter{
          display: contents;
        }
      }
      .input_wrap{
        width: 49%;
        &.main_name{
          width: 79%;
        }
      }
      .text_wrap{
        width: 100%;
        .input_text {
          width: 100%;
          resize: none;
          outline: none;
          background-color: #fffcf5;
          border-radius: 4px;
          color: #66615b;
          font-size: 14px;
          transition: background-color 0.3s ease 0s;
          padding: 7px 18px;
          height: 100px;
          box-shadow: none;
          border: 1px solid #e8e8e8;
        }
      }
      .button_wrap{
        width: 100%;
        text-align: right;
      }
    }
  }


</style>
